module.exports = __webpack_public_path__ + "img/4.65dd9622.jpg";